<nsc-card>
  <nsc-card-title>Fee Summary</nsc-card-title>
  <nsc-card-content>
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="nsc-table nsc-table--no-title mat-typography">
          <div class="nsc-table__row" *ngIf="fees.transcriptFee !== 0" tabindex="0">
            <div class="nsc-table__col nsc-table__col--label">
              <!--<strong>{{ fees.transcriptFee.description }}</strong>-->
              <strong>Transcript Quantity Fee</strong>
            </div>
            <div class="nsc-table__col nsc-table__col--value">
              <strong>{{ fees.transcriptFee | currency }}</strong>
            </div>
          </div>

          <div class="nsc-table__row" *ngIf="fees.deliveryFee !== 0 " tabindex="0">
            <div class="nsc-table__col nsc-table__col--label">
              <strong>{{ fees.deliveryFeeDescription}}</strong>
              <!--<strong>Delivery Fee:</strong>-->
            </div>
            <div class="nsc-table__col nsc-table__col--value">
              <strong>{{ fees.deliveryFee | currency }}</strong>
            </div>
          </div>

          <div class="nsc-table__row" *ngIf="fees.transcriptTypeFee !== 0" tabindex="0">
            <div class="nsc-table__col nsc-table__col--label">
              <!--<strong>{{ fees.transcriptTypeFee.description }}</strong>-->
              <strong>Transcript Type Fee</strong>
            </div>
            <div class="nsc-table__col nsc-table__col--value">
              <strong>{{ fees.transcriptTypeFee | currency }}</strong>
            </div>
          </div>

          <div class="nsc-table__row" *ngIf="fees.shippingAndHandlingFee !== 0" tabindex="0">
            <div class="nsc-table__col nsc-table__col--label">
              <!--<strong>{{ fees.shippingAndHandlingFee.description }}</strong>-->
              <strong>Shipping and Handling Fee</strong>
            </div>
            <div class="nsc-table__col nsc-table__col--value">
              <strong>{{ fees.shippingAndHandlingFee | currency }}</strong>
            </div>
          </div>

          <div class="nsc-table__row" *ngIf="fees.onlineProcessingFee !== 0" tabindex="0">
            <div class="nsc-table__col nsc-table__col--label">
              <!--<strong>{{ fees.onlineProcessingFee.description }}</strong> -->
              <strong>Online Processing Fee</strong>
            </div>
            <div class="nsc-table__col nsc-table__col--value">
              <strong>{{ fees.onlineProcessingFee | currency }}</strong>
            </div>
          </div>

          <div class="nsc-table__row" tabindex="0">
            <div class="nsc-table__col nsc-table__col--label" style="text-align: right">
              <!-- <strong>{{ fees.totalFee.description }}</strong> -->
              <strong>Total Fee for this Recipient</strong>
            </div>
            <div class="nsc-table__col nsc-table__col--value nsc-table__col--total">
              <strong>{{ fees.totalFee | currency }} </strong>
              <a *ngIf="(isSPDESchool || (isTNSchool && fees.totalFee === 0))" role="button" tabindex="0" aria-label="info" class="info-icon" (click)="viewTotalFeeTNDetails()">
                <mat-icon>info</mat-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nsc-card-content>
</nsc-card>